import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-shell',
  templateUrl: './modal-shell.component.html',
  styleUrls: ['./modal-shell.component.scss'],
})
export class ModalShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
